"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const html_custom_element_1 = require("../../../lib/html-custom-element");
const custom_element_decorators_1 = require("../../../lib/custom-element-decorators");
const reactive_decorators_1 = require("../../../lib/reactive-decorators");
const translate_1 = require("../../image-properties-dialog/translate");
const calculate_warnings_1 = require("./calculate-warnings");
exports.createMsoWarning = (translate) => {
    class MsoWarning extends html_custom_element_1.HTMLCustomElement {
        validate({ validationState, tabName, }) {
            const containerDimensions = validationState[tabName].containerDimensions;
            if (calculate_warnings_1.msoWarning(containerDimensions)) {
                return this._createMsoWarning();
            }
            return undefined;
        }
        _createMsoWarning() {
            return {
                group: 'container-dimensions',
                type: 'warning',
                message: this._translate('imageUrlMSOWarning'),
            };
        }
        _translate(key, parameters) {
            return translate(this.translations || {})(key, parameters);
        }
    }
    __decorate([
        reactive_decorators_1.JsonAttribute('translations'),
        __metadata("design:type", String)
    ], MsoWarning.prototype, "translations", void 0);
    return MsoWarning;
};
custom_element_decorators_1.CustomElement('vce-ipd-mso-warning')(exports.createMsoWarning(translate_1.translate));
//# sourceMappingURL=mso-warning.js.map